// extracted by mini-css-extract-plugin
export default {"select":"FormInput_select__xiPRg"};